import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import BroadTermsUI from './BroadTermsUI'

class BroadTermsSF extends Component {
  constructor(props) {
    super(props)

    // remove any stale draft from sessionStorage if present
    try {
      const loanId = props.match && props.match.params && props.match.params.loanId
      if (loanId && typeof sessionStorage !== 'undefined') {
        sessionStorage.removeItem(`su_broad_terms_${loanId}`)
      }
    } catch (e) {
      // ignore
    }

    const bt = (props.loan && props.loan.broadTerms) || {}
    // keep promoters blank until user selects them
    const promoterNames = ''

    this.state = {
      successMsg: null,
      errorList: null,
      previewSubmitted: false,
      sendSubmitted: false,
      submitted: false,
      sentDate: bt.broadTermsSentDate || null,
      // fields
      borrower: bt.borrower || (props.loan && props.loan.account ? props.loan.account.accountName : ''),
      borrowerError: null,
      promoters: promoterNames || '',
      promotersError: null,
      purpose: bt.purpose || (props.loan && props.loan.loanRequest ? props.loan.loanRequest.loanPurpose : (props.loan ? props.loan.purpose : '')),
      purposeError: null,
      loanAmount: bt.amount ? String(bt.amount) : (props.loan && props.loan.termSheet ? props.loan.termSheet.amountF : (props.loan && props.loan.loanRequest ? props.loan.loanRequest.amountF : '')),
      loanAmountError: null,
      loanTenor: bt.tenureMonths || (props.loan && props.loan.termSheet ? props.loan.termSheet.tenureMonths : (props.loan && props.loan.loanRequest ? props.loan.loanRequest.tenureMonths : '')),
      loanTenorError: null,
      amortizedMonths: bt.amortizedMonths || (props.loan && props.loan.termSheet ? props.loan.termSheet.amortizedMonths : (props.loan && props.loan.loanRequest ? props.loan.loanRequest.amortizedMonths : '')),
      amortizedMonthsError: null,
      revolvingMonths: bt.revolvingMonths || '',
      revolvingMonthsError: null,

      interestRate: bt.interestRate || (props.loan && props.loan.termSheet ? props.loan.termSheet.interestRate : ''),
      interestRateError: null,
      processingFees: bt.processingFeePercent || (props.loan && props.loan.termSheet ? props.loan.termSheet.processingFeePercent : ''),
      processingFeesError: null,
      upfrontSecurityFirstExclusive: bt.upfrontSecurityFirstExclusive || '',
      upfrontSecurityFirstExclusiveError: null,
      upfrontSecurityFirstPariPassu: bt.upfrontSecurityFirstPariPassu || '',
      upfrontSecurityFirstPariPassuError: null,
      upfrontSecuritySubservient: bt.upfrontSecuritySubservient || '',
      upfrontSecuritySubservientError: null,
      addSecurity: bt.addSecurity || '',
      addSecurityError: null,
      // DSRA (either months or percent)
      dsraMonths: bt.dsraMonths || '',
      dsraMonthsError: null,
      dsraPercent: bt.dsraPercent || '',
      dsraPercentError: null,
      // Security pledge vs NDU (either one)
      sharesPledgedPercent: bt.sharesPledgedPercent || '',
      sharesPledgedPercentError: null,
      nduPercent: bt.nduPercent || '',
      nduPercentError: null,
      // co-borrower pledge vs ndu (optional, shown only when coBorrower provided)
      coSharesPledgedPercent: bt.coSharesPledgedPercent || '',
      coSharesPledgedPercentError: null,
      coNduPercent: bt.coNduPercent || '',
      coNduPercentError: null,
      // selected escrow route (single string)
      selectedEscrow: bt.escrowRoute || bt.selectedEscrow || '',
      // co-borrower (optional)
      coBorrower: bt.co_borrower || bt.coBorrower || '',
      // recipient emails for Send Broad Terms (list of strings)
      recipientEmails: (bt && bt.recipientEmails) || [],
      // optional validation error for recipient input
      recipientEmailError: null,
      updatedLoan: null
    }
    this._successMsgTimer = null
    this._errorTimer = null
  }

  fetchFreshLoan = () => {
    const loanId = this.props.match && this.props.match.params && this.props.match.params.loanId
    if (!loanId) return
    RestApiUtils.get(
      this.props.context,
      `/api/su/loans/${loanId}`,
      (res) => {
        if (res && res.loan) {
          this.setState({ updatedLoan: res.loan })
        }
      }
    )
  }

  componentDidUpdate(prevProps) {

    // Merge recipientEmails from incoming loan.broadTerms into state when loan prop changes
    if (this.props.loan !== prevProps.loan) {
      const bt = (this.props.loan && this.props.loan.broadTerms) || null
      const incoming = (bt && bt.recipientEmails) || []
      if (incoming && Array.isArray(incoming) && incoming.length > 0) {
        const existing = this.state.recipientEmails || []
        // merge and dedupe while preserving existing order
        const merged = Array.from(new Set([...existing, ...incoming]))
        // update state only if new emails were added
        const needUpdate = merged.length !== existing.length || merged.some(e => !existing.includes(e))
        if (needUpdate) {
          this.setState({ recipientEmails: merged })
        }
      }
    }
  }

  onRefreshClick = (noBusy) => {
    // Remove loan cache so subsequent views fetch fresh data
    try {
      CacheManager.removeObject(CacheKeys.Loan(this.props.match.params.loanId))
    } catch (e) {
      // ignore if CacheKeys or CacheManager not available
    }
    // If caller requested 'noBusy', reload immediately; else reset small UI state then reload
    if (noBusy === 'noBusy') {
      if (this.props.history && this.props.history.go) this.props.history.go(0)
      else window.location.reload()
    } else {
      this.setState({ errorList: null }, () => {
        if (this.props.history && this.props.history.go) this.props.history.go(0)
        else window.location.reload()
      })
    }
  }

  render() {
    const activeLoan = this.state.updatedLoan || this.props.loan
    return (
      <BroadTermsUI
        context={this.props.context}
        loan={activeLoan}
        onPreview={this.onPreview}
        previewSubmitted={this.state.previewSubmitted}
        sendSubmitted={this.state.sendSubmitted}
        onSend={this.onSend}
        sentDate={this.state.sentDate}
        // fields
        borrower={this.state.borrower}
        onBorrowerChange={(e) => { this.setState({ borrower: e.target.value }) }}
        borrowerError={this.state.borrowerError}
        setBorrowerError={(error) => { this.setState({ borrowerError: error }) }}

        promoters={this.state.promoters}
        onPromotersChange={(e) => { this.setState({ promoters: e.target.value }) }}
        promotersError={this.state.promotersError}
        setPromotersError={(error) => { this.setState({ promotersError: error }) }}

        purpose={this.state.purpose}
        onPurposeChange={(e) => { this.setState({ purpose: e.target.value }) }}
        purposeError={this.state.purposeError}
        setPurposeError={(error) => { this.setState({ purposeError: error }) }}

        loanAmount={this.state.loanAmount}
        onLoanAmountChange={(value) => { this.setState({ loanAmount: value }) }}
        loanAmountError={this.state.loanAmountError}
        setLoanAmountError={(error) => { this.setState({ loanAmountError: error }) }}

        loanTenor={this.state.loanTenor}
        onLoanTenorChange={(e) => { this.setState({ loanTenor: e.target.value }) }}
        loanTenorError={this.state.loanTenorError}
        setLoanTenorError={(error) => { this.setState({ loanTenorError: error }) }}

        amortizedMonths={this.state.amortizedMonths}
        onAmortizedMonthsChange={(e) => { this.setState({ amortizedMonths: e.target.value, revolvingMonths: e.target.value ? '' : this.state.revolvingMonths }) }}
        amortizedMonthsError={this.state.amortizedMonthsError}
        setAmortizedMonthsError={(error) => { this.setState({ amortizedMonthsError: error }) }}

        revolvingMonths={this.state.revolvingMonths}
        onRevolvingMonthsChange={(e) => {
          const value = e.target.value
          this.setState({
            revolvingMonths: value,
            amortizedMonths: value ? '' : this.state.amortizedMonths
          })
        }}
        revolvingMonthsError={this.state.revolvingMonthsError}
        setRevolvingMonthsError={(error) => {
          this.setState({ revolvingMonthsError: error })
        }}

        interestRate={this.state.interestRate}
        onInterestRateChange={(e) => { this.setState({ interestRate: e.target.value }) }}
        interestRateError={this.state.interestRateError}
        setInterestRateError={(error) => { this.setState({ interestRateError: error }) }}

        processingFees={this.state.processingFees}
        onProcessingFeesChange={(e) => { this.setState({ processingFees: e.target.value }) }}
        processingFeesError={this.state.processingFeesError}
        setProcessingFeesError={(error) => { this.setState({ processingFeesError: error }) }}

        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}

        // dsra
        dsraMonths={this.state.dsraMonths}
        onDsraMonthsChange={this.onDsraMonthsChange}
        dsraMonthsError={this.state.dsraMonthsError}
        setDsraMonthsError={(error) => { this.setState({ dsraMonthsError: error }) }}
        dsraPercent={this.state.dsraPercent}
        onDsraPercentChange={this.onDsraPercentChange}
        dsraPercentError={this.state.dsraPercentError}
        setDsraPercentError={(error) => { this.setState({ dsraPercentError: error }) }}

        // pledge vs ndu
        sharesPledgedPercent={this.state.sharesPledgedPercent}
        onSharesPledgedPercentChange={this.onSharesPledgedPercentChange}
        sharesPledgedPercentError={this.state.sharesPledgedPercentError}
        setSharesPledgedPercentError={(error) => { this.setState({ sharesPledgedPercentError: error }) }}
        nduPercent={this.state.nduPercent}
        onNduPercentChange={this.onNduPercentChange}
        nduPercentError={this.state.nduPercentError}
        setNduPercentError={(error) => { this.setState({ nduPercentError: error }) }}
        coSharesPledgedPercent={this.state.coSharesPledgedPercent}
        onCoSharesPledgedPercentChange={this.onCoSharesPledgedPercentChange}
        coSharesPledgedPercentError={this.state.coSharesPledgedPercentError}
        setCoSharesPledgedPercentError={(error) => { this.setState({ coSharesPledgedPercentError: error }) }}
        coNduPercent={this.state.coNduPercent}
        onCoNduPercentChange={this.onCoNduPercentChange}
        coNduPercentError={this.state.coNduPercentError}
        setCoNduPercentError={(error) => { this.setState({ coNduPercentError: error }) }}

        // upfront security breakdown
        upfrontSecurityFirstExclusive={this.state.upfrontSecurityFirstExclusive}
        onUpfrontSecurityFirstExclusiveChange={(e) => { this.setState({ upfrontSecurityFirstExclusive: e.target.value }) }}
        upfrontSecurityFirstExclusiveError={this.state.upfrontSecurityFirstExclusiveError}
        setUpfrontSecurityFirstExclusiveError={(error) => { this.setState({ upfrontSecurityFirstExclusiveError: error }) }}
        upfrontSecurityFirstPariPassu={this.state.upfrontSecurityFirstPariPassu}
        onUpfrontSecurityFirstPariPassuChange={(e) => { this.setState({ upfrontSecurityFirstPariPassu: e.target.value }) }}
        upfrontSecurityFirstPariPassuError={this.state.upfrontSecurityFirstPariPassuError}
        setUpfrontSecurityFirstPariPassuError={(error) => { this.setState({ upfrontSecurityFirstPariPassuError: error }) }}
        upfrontSecuritySubservient={this.state.upfrontSecuritySubservient}
        onUpfrontSecuritySubservientChange={(e) => { this.setState({ upfrontSecuritySubservient: e.target.value }) }}
        upfrontSecuritySubservientError={this.state.upfrontSecuritySubservientError}
        setUpfrontSecuritySubservientError={(error) => { this.setState({ upfrontSecuritySubservientError: error }) }}
        addSecurity={this.addSecurity}
        onAddSecurityChange={(e) => { this.setState({ addSecurity: e.target.value }) }}
        addSecurityError={this.state.addSecurityError}
        setAddSecurityError={(error) => { this.setState({ addSecurityError: error }) }}
        coBorrower={this.state.coBorrower}
        onCoBorrowerChange={(e) => { this.setState({ coBorrower: e.target.value }) }}
        selectedEscrowRoute={this.state.selectedEscrow}
        onEscrowRouteChange={(val) => { this.setState({ selectedEscrow: val }) }}
        // recipient emails UI handlers
        recipientEmails={this.state.recipientEmails}
        onAddRecipientEmail={(email) => { this.onAddRecipientEmail(email) }}
        onRemoveRecipientEmail={(email) => { this.onRemoveRecipientEmail(email) }}
      />
    )
  }

  onPreview = () => {
    // prevent duplicate operations
    if (this.state.previewSubmitted) return

    const loanId = this.props.match.params.loanId
    // try to determine accountId from loan object
    const accountId = (this.props.loan && this.props.loan.account && (this.props.loan.account.accountId || this.props.loan.account.id)) || this.props.loan && this.props.loan.accountId || (this.props.context && this.props.context.account && this.props.context.account.accountId)

    // if accountId missing, fallback to opening preview route (best-effort)
    if (!accountId) {
      window.open(`/su/loans/${loanId}/broadTerms/preview`, '_blank')
      return
    }

    this.setState({ successMsg: null, errorList: [], previewSubmitted: true })

    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${accountId}/loans/${loanId}/fileDownloadSignedUrl`,
      this.onPreviewCallback
    )
  }

  onPreviewCallback = (response) => {
    const errorList = []
    if (response && response.errorList) {
      response.errorList.forEach(e => {
        if (e && e.message) errorList.push(e.message)
      })
    }

    if (response && response.signedUrl && response.signedUrl.signedUrl) {
      // open signed url in new tab/window to trigger browser download
      window.open(response.signedUrl.signedUrl, '_blank')
      // show friendly success message
      this.setSuccessMsg(response.success || 'Preview ready')
      this.setState({ errorList: errorList, previewSubmitted: false })
      // auto-clear error(s) after 5 seconds
      if (this._errorTimer) {
        clearTimeout(this._errorTimer)
        this._errorTimer = null
      }
      if (errorList.length > 0) {
        this._errorTimer = setTimeout(() => {
          this.setState({ errorList: null })
          this._errorTimer = null
        }, 5000)
      }
      // fetch fresh loan in background without page reload
      this.fetchFreshLoan()
    } else {
      // show errors if any or generic error
      if (!response || (!response.signedUrl && (!response.errorList || response.errorList.length === 0))) {
        errorList.push('Unable to get preview URL')
      }
      this.setState({ errorList: errorList, previewSubmitted: false })
      // auto-clear error(s) after 5 seconds
      if (this._errorTimer) {
        clearTimeout(this._errorTimer)
        this._errorTimer = null
      }
      if (errorList.length > 0) {
        this._errorTimer = setTimeout(() => {
          this.setState({ errorList: null })
          this._errorTimer = null
        }, 5000)
      }
      if (errorList.length > 0) window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
  }

  onAddRecipientEmail = (email) => {
    if (!email || String(email).trim() === '') {
      this.setErrorList(['Please enter an email address'])
      return
    }
    const e = String(email).trim()
    // basic email validation
    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRe.test(e)) {
      this.setErrorList([`Invalid email address: ${e}`])
      return
    }
    const existing = this.state.recipientEmails || []
    if (existing.includes(e)) {
      this.setErrorList([`Email already added: ${e}`])
      return
    }
    const next = [...existing, e]
    this.setState({ recipientEmails: next })
  }

  onRemoveRecipientEmail = (email) => {
    if (!email) return
    const next = (this.state.recipientEmails || []).filter(e => e !== email)
    this.setState({ recipientEmails: next })
  }

  onSend = () => {
    if (this.state.sendSubmitted) return

    const loanId = this.props.match.params.loanId
    // try to determine accountId from loan object or context
    const accountId = (this.props.loan && this.props.loan.account && (this.props.loan.account.accountId || this.props.loan.account.id)) || this.props.loan && this.props.loan.accountId || (this.props.context && this.props.context.account && this.props.context.account.accountId)

    if (!accountId) {
      // show friendly error if account id is not available
      this.setErrorList(['Unable to determine account id for sending Broad Terms'])
      return
    }

    // collect recipients (may be empty) — allow sending even if none provided
    const recipients = this.state.recipientEmails || []

    this.setState({
      successMsg: null,
      errorList: [],
      sendSubmitted: true,
      // Clear form values on send
      promoters: '',
      purpose: '',
      loanAmount: '',
      loanTenor: '',
      amortizedMonths: '',
      revolvingMonths: '',
      interestRate: '',
      processingFees: '',
      upfrontSecurityFirstExclusive: '',
      upfrontSecurityFirstPariPassu: '',
      upfrontSecuritySubservient: '',
      addSecurity: '',
      dsraMonths: '',
      dsraPercent: '',
      sharesPledgedPercent: '',
      nduPercent: '',
      coSharesPledgedPercent: '',
      coNduPercent: '',
      selectedEscrow: '',
      coBorrower: '',
      recipientEmails: []
    })
    // API expects SendBroadTermsPostRequestDTO with field `recipientsEmails`
    const body = { recipientsEmails: recipients }
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${accountId}/loans/${loanId}/sendBroadTerms`,
      this.onSendCallback,
      body
    )
  }

  onSubmit = () => {
    // only proceed if not already submitting
    if (this.state.submitted)
      return

    // Ensure generate button was enabled before allowing submit
    const loanAmountText = this.state.loanAmount;
    const requiredFilled =
      loanAmountText !== '' &&
      this.state.interestRate && String(this.state.interestRate).trim() !== '' &&
      this.state.purpose && String(this.state.purpose).trim() !== '' &&
      this.state.processingFees && String(this.state.processingFees).trim() !== '' &&
      this.state.loanTenor && String(this.state.loanTenor).trim() !== '';

    const dsraProvided = (this.state.dsraMonths && String(this.state.dsraMonths).trim() !== '') || (this.state.dsraPercent && String(this.state.dsraPercent).trim() !== '')
    const pledgeOrNduProvided = (this.state.sharesPledgedPercent && String(this.state.sharesPledgedPercent).trim() !== '') || (this.state.nduPercent && String(this.state.nduPercent).trim() !== '')
    const escrowProvided = this.state.selectedEscrow && String(this.state.selectedEscrow).trim() !== ''
    const generateEnabled = Boolean(requiredFilled && dsraProvided && pledgeOrNduProvided && escrowProvided)
    if (!generateEnabled) return

    this.setState({ successMsg: null, errorList: [], submitted: true })

    // Build request body according to GenerateBroadTermsPostRequestDTO
    const toStr = (v) => (v === null || v === undefined) ? '' : String(v).trim()
    // promoters: convert comma-separated string to list or pass array as-is
    let promotersList = []
    if (Array.isArray(this.state.promoters)) {
      // array may contain the literal 'Not applicable' if stored that way
      if (this.state.promoters.length === 1 && String(this.state.promoters[0]).trim().toLowerCase() === 'not applicable') {
        promotersList = []
      } else {
        promotersList = this.state.promoters.filter(Boolean)
      }
    } else if (this.state.promoters) {
      const pstr = String(this.state.promoters).trim()
      if (pstr.toLowerCase() === 'not applicable') {
        promotersList = []
      } else {
        promotersList = pstr.split(',').map(s => s.trim()).filter(Boolean)
      }
    }

    const coBorrowerVal = this.state.coBorrower && String(this.state.coBorrower).trim() !== '' ? String(this.state.coBorrower).trim() : null

    const body = {
      loanId: this.props.match.params.loanId,
      coBorrower: coBorrowerVal,
      promoters: promotersList,
      amount: (this.state.loanAmount),
      tenureMonths: toStr(this.state.loanTenor),
      amortizedMonths: toStr(this.state.amortizedMonths),
      revolvingMonths: toStr(this.state.revolvingMonths),
      purpose: toStr(this.state.purpose),
      interestRate: toStr(this.state.interestRate),
      processingFeePercent: toStr(this.state.processingFees),
      dsraMonths: toStr(this.state.dsraMonths),
      dsraPercent: toStr(this.state.dsraPercent),
      sharePledgePercent: toStr(this.state.sharesPledgedPercent),
      nduPercent: toStr(this.state.nduPercent),
      coBorrowerSharePledgePercent: toStr(this.state.coSharesPledgedPercent),
      coBorrowerNduPercent: toStr(this.state.coNduPercent),
      firstExclusiveAssets: toStr(this.state.upfrontSecurityFirstExclusive),
      firstPariPassuAssets: toStr(this.state.upfrontSecurityFirstPariPassu),
      subservientAssets: toStr(this.state.upfrontSecuritySubservient),
      additionalSecurity: toStr(this.state.addSecurity),
      escrowRoute: toStr(this.state.selectedEscrow)
    }

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.match.params.loanId}/documents/generate/broadTerms`,
      this.onGenerateCallback,
      body
    )
  }

  onGenerateCallback = (response) => {
    // handle generate response
    const errorList = []

    // If errors, collect messages from API and display them directly
    if (response && response.errorList) {
      response.errorList.forEach(error => {
        if (error && error.message) errorList.push(error.message)
      })
    }

    // handle signed url success
    if (response && response.signedUrl && response.signedUrl.signedUrl) {
      // open the signed url in new tab/window to trigger download
      window.open(response.signedUrl.signedUrl, '_blank')
      // show a friendly success message for generate
      this.setSuccessMsg(response.success || 'Broad Terms Generated successfully')

      // Optimistically update broadTerms status to enable preview & send without reloading page
      const currentLoan = this.state.updatedLoan || this.props.loan || {}
      const updatedBroadTerms = {
        ...(currentLoan.broadTerms || {}),
        status: 'broad_terms_generated',
        broadTermsStatus: 'broad_terms_generated',
        broadTermsCreatedDate: new Date().toISOString().split('T')[0]
      }
      this.setState({
        errorList: errorList,
        submitted: false,
        updatedLoan: { ...currentLoan, broadTerms: updatedBroadTerms }
      })

      // Fetch fresh loan in background to sync server state without reloading page
      this.fetchFreshLoan()
    } else {
      // no signed url - show errors (if any) or success
      if (response && response.success) {
        this.setSuccessMsg(response.success || 'Broad Terms Generated successfully')
      }
      this.setState({ errorList: errorList, submitted: false })
    }
  }

  onSendCallback = (response) => {
    const errorList = []
    if (response && response.errorList) {
      response.errorList.forEach(e => {
        if (e && e.message) errorList.push(e.message)
        else if (typeof e === 'string') errorList.push(e)
      })
    }

    // show success message if any (setSuccessMsg auto-clears after 5s)
    if (response && response.success) {
      this.setSuccessMsg(response.success)
      // fetch fresh loan in background without page reload
      this.fetchFreshLoan()
    }

    // Update sentDate if present in response
    if (response && response.loan && response.loan.broadTerms) {
      this.setState({ sentDate: response.loan.broadTerms.broadTermsSentDate })
    }

    // display errors (setErrorList will auto-clear after 5s)
    this.setState({ sendSubmitted: false })
    if (errorList.length > 0) {
      this.setErrorList(errorList)
    } else {
      // clear any visible errors
      this.setState({ errorList: null })
    }
  }

  // Note: detailed field-level error mapping for certain API responses is
  // handled in other callbacks. Removed unused/duplicate handler to keep
  // this component focused and concise.

  setSuccessMsg = (msg) => {
    // clear previous timer
    if (this._successMsgTimer) {
      clearTimeout(this._successMsgTimer)
      this._successMsgTimer = null
    }
    this.setState({ successMsg: msg })
    if (msg) {
      // auto-clear after 5 seconds
      this._successMsgTimer = setTimeout(() => {
        this.setState({ successMsg: null })
        this._successMsgTimer = null
      }, 5000)
    }
  }

  componentWillUnmount() {
    if (this._successMsgTimer) {
      clearTimeout(this._successMsgTimer)
      this._successMsgTimer = null
    }
    if (this._errorTimer) {
      clearTimeout(this._errorTimer)
      this._errorTimer = null
    }
  }

  onDsraMonthsChange = (e) => {
    const value = e.target.value
    this.setState({ dsraMonths: value, dsraPercent: value ? '' : this.state.dsraPercent })
  }

  onDsraPercentChange = (e) => {
    const value = e.target.value
    this.setState({ dsraPercent: value, dsraMonths: value ? '' : this.state.dsraMonths })
  }

  onSharesPledgedPercentChange = (e) => {
    const value = e.target.value
    this.setState({ sharesPledgedPercent: value, nduPercent: value ? '' : this.state.nduPercent })
  }

  onNduPercentChange = (e) => {
    const value = e.target.value
    this.setState({ nduPercent: value, sharesPledgedPercent: value ? '' : this.state.sharesPledgedPercent })
  }

  // co-borrower pledge vs ndu handlers: mirror behaviour of primary borrower fields
  onCoSharesPledgedPercentChange = (e) => {
    const value = e.target.value
    this.setState({ coSharesPledgedPercent: value, coNduPercent: value ? '' : this.state.coNduPercent })
  }

  onCoNduPercentChange = (e) => {
    const value = e.target.value
    this.setState({ coNduPercent: value, coSharesPledgedPercent: value ? '' : this.state.coSharesPledgedPercent })
  }

  setErrorList = (errorList) => {
    // clear any previous error timer
    if (this._errorTimer) {
      clearTimeout(this._errorTimer)
      this._errorTimer = null
    }

    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      // auto-clear after 5 seconds
      this._errorTimer = setTimeout(() => {
        this.setState({ errorList: null })
        this._errorTimer = null
      }, 5000)
    }
  }
}

export default withRouter(BroadTermsSF)


